export default function PrivacyPolicyContent() {
	return (
		<>
			<section className="mb-10">
				<p className="text-zinc-700 leading-relaxed">
					Na Grinsper, o cumprimento da Lei Geral de Proteção de Dados não é o nosso ponto de chegada, mas o nosso ponto de partida.
					Acreditamos que a transparência e o consentimento não devem ser vistos como fardos burocráticos,
					mas como <strong>ativos de relacionamento</strong> que fortalecem a confiança entre quem cuida dos dados e quem os gera.
				</p>
				<br />
				<p className="text-zinc-700 leading-relaxed mb-4">
					Esta política se aplica a todas as soluções da Grinsper destinadas a pessoas físicas e organizações. Sempre que houver regras específicas para um determinado serviço, elas serão indicadas ao longo deste documento.
				</p>

				<div className="text-zinc-700 leading-relaxed mt-4">
					Para fins desta política, adotamos as seguintes definições:
					<ul className="list-disc list-inside space-y-2 mt-4">
						<li><strong> Solicitante:</strong> pessoa que solicita um serviço da Grinsper.</li>
						<li><strong> Titular do Produto:</strong> organização ou pessoa responsável pelo produto digital submetido à avaliação (quando aplicável).</li>
						<li><strong> Titular de Dados:</strong> pessoa natural cujos dados pessoais são tratados pela Grinsper ou pelo produto avaliado.</li>
					</ul>
				</div>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Projetamos nossas soluções para transformar a privacidade em uma experiência mais clara, transparente e confiável.
				</p>
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">1. Solicitamos apenas os dados necessários</h2>
				<p className="text-zinc-700 leading-relaxed mb-4">
					Na solicitação inicial de nossos serviços, coletamos apenas as informações necessárias para identificar o pedido e iniciar o atendimento.
				</p>
				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2">
					<li>
						<strong>Para pessoas:</strong> nome e e-mail.
					</li>
					<li>
						<strong>Para organizações:</strong> e-mail corporativo e endereço do produto digital (site, aplicativo, plataforma ou outro ambiente a ser avaliado).
					</li>
				</ul>
				<p className="text-zinc-700 leading-relaxed mt-4 mb-4">
					Caso seja necessário para analisar a solicitação, definir o escopo, formalizar a contratação ou executar o serviço, poderemos solicitar informações complementares, como:
				</p>
				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2">
					<li>
						<strong>Para pessoas:</strong> telefone, WhatsApp, CPF ou outras informações estritamente necessárias para identificação, contratação ou atendimento.
					</li>
					<li>
						<strong>Para organizações:</strong> identificação do responsável, nome da organização, CNPJ, informações técnicas sobre o produto ou outros dados necessários para definir o escopo ou executar o serviço.
					</li>
				</ul>
				<p className="text-zinc-700 leading-relaxed mt-4 italic text-sm">
					Importante: Não solicitamos dados pessoais sensíveis como requisito para utilização dos nossos serviços. Caso essas informações sejam enviadas espontaneamente pelo titular ou sejam indispensáveis para a análise da solicitação, elas serão tratadas com proteção adicional, observando a LGPD e os princípios da necessidade e minimização.
				</p>
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">2. A quem pertencem os resultados da avaliação e do serviço?</h2>

				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2 mt-4">
					<li>Os dados pessoais continuam pertencendo aos respectivos titulares.</li>
					<li>Os relatórios e entregáveis produzidos pela Grinsper pertencem ao cliente que contratou o serviço</li>
					<li>A metodologia, modelos, processos, critérios técnicos e propriedade intelectual utilizados pela Grinsper permanecem de titularidade da Grinsper.</li>
				</ul>
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">3. Ciclo de vida e retenção consciente</h2>
				<p className="text-zinc-700 leading-relaxed mb-4">
					Estabelecemos ciclos de vida curtos e específicos para cada informação.
					Tratamos seus dados respeitando o tempo estritamente necessário para cumprir sua finalidade:
				</p>
				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2">
					<li><strong>Dados de execução (organizações):</strong> dados técnicos utilizados durante a execução do serviço, incluindo contas de teste e dados sintéticos criados para avaliação da experiência do usuário, quando aplicável, são <strong>eliminados imediatamente</strong> após a finalização do serviço.
					</li>
					<li><strong>Entregáveis e relatórios (organizações e pessoas):</strong> Para garantir que você tenha suporte e acesso aos resultados, mantemos os relatórios finais por até <strong>90 dias</strong> após a entrega. No caso de encerramento do seu plano de recorrência, todos os relatórios gerados ficam disponíveis por mais 90 dias após o término da vigência.
					</li>
					<li><strong>Dados de contato (organizações e pessoas):</strong> Mantidos apenas durante o período necessário para o relacionamento contratual ou conforme exigência legal.
					</li>
				</ul>
				<p className="text-zinc-700 leading-relaxed mt-4 italic text-sm">
					Importante: Após esses períodos, os dados são destruídos ou anonimizados de forma irreversível, deixando de ser considerados dados pessoais.
				</p>
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">4. Seus dados não são mercadoria</h2>
				<p className="text-zinc-700 leading-relaxed">
					Tratamos prioritariamente dados fornecidos diretamente por você (zero-party data). Isso significa que operamos sob a premissa de que você mantém o controle sobre as informações que compartilha conosco:
				</p>
				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2 mt-4">
					<li>
						<strong>Origem direta:</strong> utilizamos apenas dados explicitamente fornecidos por você. Tratamos essas informações com rigorosa confidencialidade dentro da nossa infraestrutura.
					</li>
					<li>
						<strong>Sem intermediários:</strong> não compramos, não vendemos e não enriquecemos nossa base de dados com informações de terceiros ou oriundas de corretores de dados.
					</li>
					<li>
						<strong>Propósito restrito:</strong> não compartilhamos seus dados para fins comerciais. Qualquer compartilhamento só ocorrerá se houver exigência legal ou se você autorizar previamente para uma finalidade específica e claramente informada.
					</li>
				</ul>
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">5. Transparência sobre Cookies</h2>
				<p className="text-zinc-700 leading-relaxed">
					A Grinsper <strong>não utiliza cookies de rastreamento, marketing ou analytics invasivo</strong>. Acreditamos que sua navegação deve ser respeitada e não monitorada para fins comerciais.
				</p>
				<p className="text-zinc-700 leading-relaxed mt-4">
					Caso a Grinsper passe a utilizar cookies além daqueles estritamente necessários, os mecanismos de consentimento serão apresentados de forma clara, transparente e respeitando a granularidade do controle do usuário, garantindo que você tenha total autonomia sobre quais cookies deseja permitir.
				</p>
				{/*<p className="text-zinc-700 leading-relaxed mt-4">
					Nossa infraestrutura de tecnologia (como hospedagem e banco de dados) utiliza apenas cookies <strong>estritamente técnicos e essenciais</strong> para garantir a segurança e a estabilidade da sua conexão. Como não fazemos uso de cookies de publicidade ou de preferência, você não encontrará banners de interrupção ou pedidos de consentimento desnecessários em nossa página.
				</p>*/}
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">6. Você está no controle</h2>
				<p className="text-zinc-700 leading-relaxed mb-4">
					Garantimos o seu direito de <strong>acesso, correção, revogação do consentimento e exclusão</strong> de seus dados a qualquer momento. Não dificultamos esse processo. Afinal, autonomia, transparência e confiança são nossos valores.
				</p>
				<p className="text-zinc-700 leading-relaxed mb-4">
					Priorizamos o consentimento informado e granular: você sempre saberá exatamente para que cada dado está sendo solicitado, de forma clara e transparente, no exato momento da coleta.
				</p>
			</section >

			<section className="mb-10" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">7. Como protegemos seus dados</h2>
				<p className="text-zinc-700 leading-relaxed mb-4">
					Adotamos medidas técnicas e organizacionais compatíveis com a natureza dos dados tratados para protegê-los contra acesso não autorizado, alteração, perda, destruição ou divulgação indevida. Essas medidas são continuamente revistas de acordo com a evolução dos riscos e das boas práticas de segurança.
				</p>
			</section >

			<section className="mb-5" >
				<h2 className="text-xl font-medium mb-3 text-zinc-800">8. Contato e resolução de dúvidas</h2>
				<p className="text-zinc-700 leading-relaxed mb-4">
					Privacidade é uma relação de confiança. Se você tiver qualquer dúvida sobre esta política ou sobre a forma como tratamos seus dados, entre em contato conosco. Faremos o possível para responder de forma clara e transparente.
				</p>
				<div className="bg-zinc-50 border border-zinc-200 p-6 rounded-lg">
					<a href="mailto:transparencia@grinsper.com" className="custom-link font-medium text-zinc-900 underline underline-offset-4">
						transparencia@grinsper.com
					</a>
				</div>
			</section >

			<section className="mb-10 border-t border-zinc-100 pt-5">
				<p className="text-sm text-zinc-500 leading-relaxed italic">
					Esta política reflete nosso compromisso com a transparência, a confiança e o respeito à privacidade. Ela poderá ser atualizada periodicamente para refletir melhorias em nossos processos, alterações legais ou a evolução das soluções da Grinsper.
				</p>
				<p className="text-xs text-zinc-400 mt-4">
					O conteúdo desta política constitui propriedade intelectual da Grinsper e é protegido pela Lei nº 9.610/98. É vedada sua reprodução, adaptação ou utilização para fins comerciais sem autorização prévia da Grinsper.
				</p>
				<p className="text-center text-sm text-zinc-500 italic mt-3 mb-3">
					Versão 1.0 (atualizada em 30.06.2026) | Grinsper Inova Simples  I.S. | CNPJ: 64.967.842/0001-08
				</p>
			</section>
		</>
	);
}
